import { useRef, useState } from "react";
import { api, formatApiErrorDetail } from "../lib/api";
import { toast } from "sonner";
import { Camera, Loader2 } from "lucide-react";

export const PhotoUpload = ({ userId, onDone, testId, small }) => {
  const ref = useRef(null);
  const [busy, setBusy] = useState(false);
  const pick = async (e) => {
    const file = e.target.files?.[0];
    e.target.value = "";
    if (!file) return;
    if (!file.type.startsWith("image/")) { toast.error("Escolha um ficheiro de imagem (JPG, PNG ou WEBP)"); return; }
    setBusy(true);
    try {
      const fd = new FormData();
      fd.append("file", file);
      const r = await api.post(`/users/${userId}/photo`, fd);
      toast.success("Fotografia atualizada");
      onDone?.(r.data);
    } catch (err) { toast.error(formatApiErrorDetail(err.response?.data?.detail) || "Erro ao carregar a fotografia"); }
    setBusy(false);
  };
  return (
    <>
      <button type="button" onClick={() => ref.current?.click()} disabled={busy} data-testid={testId} title="Carregar fotografia"
        className={`absolute bottom-0 right-0 rounded-full bg-[#C9A84C] text-[#0D1B2A] shadow-lg hover:scale-110 transition-transform disabled:opacity-60 flex items-center justify-center ${small ? "w-6 h-6 -right-1.5 -bottom-1.5 ring-2 ring-[#0D1B2A]" : "w-9 h-9"}`}>
        {busy ? <Loader2 size={small ? 12 : 16} className="animate-spin" /> : <Camera size={small ? 12 : 16} />}
      </button>
      <input ref={ref} type="file" accept="image/jpeg,image/png,image/webp" hidden onChange={pick} data-testid={`${testId}-input`} />
    </>
  );
};
